
import { Component, Vue } from 'vue-property-decorator'
import { CompanyClient } from '@/api'
import CompanyEditor from './editor.vue'
import BaseList from '@/views/BaseList'
import _ from 'lodash'
import { setTimeout } from 'timers'
import { ICompanyData } from '@/api/types'

@Component({
  name: 'StationList',
  components: {
    CompanyEditor
  }
})
export default class extends BaseList {
  public constructor() {
    super()
    this.client = new CompanyClient()
    this.listQuery = {
      filter: {
        where: { name: { like: '' } },
        fields: {
          id: true,
          name: true,
          nickName: true,
          address: true,
          phone: true,
          business_license_number: true,
          legal_person: true,
          legal_person_mobile_phone_number: true,
          contact_person: true,
          contact_person_mobile_phone_number: true,
          bank_card_number: true,
          bank_name: true,
          account_balance: true,
          discount: true,
          qr_image_url: true,
          createdAt: true
        },
        limit: 10,
        page: 1,
        skip: 0,
        order: ['createdAt desc']
      }
    }
  }

  async created() {
    super.created()
  }

  protected generateQuery():any {
    const t = _.cloneDeep(this.listQuery)
    t.filter.where.name.like = `%${this.listQuery.filter.where.name.like}%`
    return t
  }

  protected async handleFilter() {
    super.handleFilter()
  }

  protected async handleSizeChange(val: number) {
    super.handleSizeChange(val)
  }

  protected async handleCurrentChange(val: number) {
    super.handleCurrentChange(val)
  }

  protected async handleCreate() {
    super.handleCreate()
  }

  protected async handleUpdate(row: ICompanyData) {
    super.handleUpdate(row)
  }

  protected async handleDelete(row: ICompanyData) {
    super.handleDelete(row)
  }

  protected async saveData() {
    super.saveData()
  }
}
